module.exports = __webpack_public_path__ + "img/copy_trash_white_circle.00fb433f.png";